import React from 'react';
import ReactDom from 'react-dom';
import { clsx } from 'clsx';

type Props = {
  title?: string;
  isSubmitDisabled?: boolean;
  onCancel?: () => void;
  onSubmit: () => void;
  children?: React.ReactNode;
};

export const Modal = React.forwardRef<HTMLDivElement, Props>(
  ({ title, isSubmitDisabled, onCancel, onSubmit, children }, ref) =>
    ReactDom.createPortal(
      <div className="fixed bottom-0 inset-x-0 sm:px-4 sm:pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
        {/*
        Background overlay, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0"
          To: "opacity-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100"
          To: "opacity-0"
      */}
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-500 opacity-75" />
        </div>

        {/*
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      */}
        <div
          className="bg-white rounded-lg px-1 sm:px-4 pt-2 sm:pt-5 pb-4 w-full overflow-hidden shadow-xl transform transition-all sm:max-w-md sm:p-6"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
          ref={ref}
        >
          {title && <h2 className="text-xl font-bold leading-5 text-gray-900 mb-3">{title}</h2>}

          {children}
          <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
            <span className="flex w-full rounded-md shadow-sm sm:col-start-2">
              <button
                type="button"
                className={clsx(
                  'inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-teal-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-teal-500 focus:outline-none focus:border-teal-700 focus:ring-teal transition ease-in-out duration-150 sm:text-sm sm:leading-5',
                  { 'opacity-50 cursor-not-allowed': isSubmitDisabled }
                )}
                disabled={isSubmitDisabled}
                onClick={onSubmit}
              >
                Guardar
              </button>
            </span>

            {onCancel && (
              <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
                <button
                  type="button"
                  className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                  onClick={onCancel}
                >
                  Cancelar
                </button>
              </span>
            )}
          </div>
        </div>
      </div>,
      document.body
    )
);

Modal.displayName = 'ModalComponent';
